import { AuthGateway } from "../gateway/AuthGateway";
import {Injectable} from "@angular/core";
import { AuthUser } from "src/app/domain/models/AuthUser";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BasicUser } from "src/app/domain/models/User";
import { BehaviorSubject, filter, Observable, switchMap, timer } from "rxjs";
import { SecurityGateway } from "../gateway/SecurityGateway";
import { jwtDecode } from "jwt-decode";
import { JwtPayload } from "src/app/domain/models/JwtPayload";
import { TokenResponse } from "src/app/domain/models/TokenResponse";
import { Routes } from "src/app/infrastructure/routes";

@Injectable({providedIn: 'root'})
export class AuthApiService extends AuthGateway {
  private static accessToken: string | null
  private static refreshToken: string | null
  private token$ =
    new BehaviorSubject<string | null>(null);

  constructor(
    private _http: HttpClient
  ) {
    super();
    AuthApiService.accessToken = localStorage.getItem('_token_auth')
    AuthApiService.refreshToken = localStorage.getItem('_refresh_token_auth')

    if(AuthApiService.accessToken)
      this.token$.next(AuthApiService.accessToken)

    this.token$
    .pipe(

        filter(x => !!x),

        switchMap(token => {
            const expiration = this.getExpiration(token!);

            const delay =
                expiration.getTime()
                - Date.now()
                - 120000;

            return timer(Math.max(delay, 0));

        })

    )
    .subscribe(() => {
        this.refreshToken();

    });
  }

  private static parseJwt(token: string) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(jsonPayload)
  }

  authenticate(token: string, refreshToken?: string): void {
    localStorage.setItem('_token_auth', token)
    localStorage.setItem('_refresh_token_auth', refreshToken ? refreshToken : '')
    AuthApiService.refreshToken = refreshToken ? refreshToken : ''
    AuthApiService.accessToken = token
    this.token$.next(token);
  }

  getToken(): string {
    return AuthApiService.accessToken ? AuthApiService.accessToken : "";
  }

  getRefreshToken(): string {
    return AuthApiService.refreshToken ? AuthApiService.refreshToken : "";
  }

  getUser(): BasicUser | undefined {
    const localStorageValue = localStorage.getItem('_auth_user')
    if(localStorageValue)
      return JSON.parse(localStorageValue)

    return undefined
  }

  private getJwtObject(): any {
    if (!AuthApiService.accessToken) return null
    return AuthApiService.parseJwt(AuthApiService.accessToken)
  }

  getCompleteName(): string {
    const jwt = this.getJwtObject()
    return jwt ? jwt.complete_name : null
  }

  getUsername(): string {
    const jwt = this.getJwtObject()
    return jwt ? jwt.unique_name : null
  }

  getRole(): string {
    const jwt = this.getJwtObject()
    return jwt ? jwt.role : null
  }

  isAuthenticated(): boolean {
    if (!AuthApiService.accessToken) return false
    let jwt = AuthApiService.parseJwt(AuthApiService.accessToken)
    return jwt.exp >= Date.now() / 1000
  }

  logout(): void {
    const storedDisclaimer = localStorage.getItem('_dsclm_sh');
    localStorage.clear()
    sessionStorage.clear()
    if(storedDisclaimer){
      localStorage.setItem('_dsclm_sh', JSON.stringify(JSON.parse(storedDisclaimer)));
      sessionStorage.setItem('_disclaimer_', JSON.stringify(JSON.parse(storedDisclaimer)));
    }
    AuthApiService.accessToken = ''
    AuthApiService.refreshToken = ''
  }

  getHttpHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getToken()}`
    })
  }

  private doRefreshToken(accessToken: string, refreshToken: string): Observable<TokenResponse> {
    return this._http.post<TokenResponse>(Routes.securityApi + '/RefreshToken', {
      "accessToken": accessToken,
      "refreshToken": refreshToken
    })
  }

  private refreshToken():void {
    var token = this.getToken();
    var refreshToken = this.getRefreshToken();
    this.doRefreshToken(
      token, refreshToken
    ).subscribe({
      next: (v) => {
        this.authenticate(v.data.accessToken, v.data.refreshToken)
      },
      error: (error) => {
        console.error('Error refreshing token:', error)
        // this.logout()
      }
    })
  }

  private getExpiration(token: string): Date {

    const jwt = jwtDecode<JwtPayload>(token);
    console.warn('Token expiration time:', jwt.exp);
    return new Date(jwt.exp * 1000);
  }



}
